import Cookies from "js-cookie";
const ylDomain = "youngliving.com";
const cookieName = "YL-SLO";
let intervalCreated = false;
let intervalId = 0;
let initialCookiePresent;
let initialUserId;
let sessionChangeCallback;
export function establishUniversalDomainSession(userId) {
    createDomainLevelCookie(userId);
}
//Set the interval and hit the cookie check to trigger the state change engine...
export function onUniversalSessionStatusChange({ onSessionChangeCallback }) {
    sessionChangeCallback = onSessionChangeCallback;
    setCookieCheckInterval();
}
export function revokeUniversalDomainSession() {
    removeCookieOnLogout();
}
function setCookieCheckInterval() {
    if (intervalCreated) {
        return;
    }
    intervalCreated = true;
    const userId = Cookies.get(cookieName);
    initialCookiePresent = userId != undefined;
    sessionChangeCallback(initialCookiePresent, userId != 'true' ? userId : undefined);
    intervalId = window.setInterval(() => {
        return checkCookie();
    }, 1000);
}
function checkCookie() {
    const userId = Cookies.get(cookieName);
    const hasCookie = userId != undefined;
    if (initialCookiePresent != hasCookie || userId != initialUserId) {
        initialCookiePresent = hasCookie;
        initialUserId = userId;
        sessionChangeCallback(initialCookiePresent, userId != 'true' ? userId : undefined);
    }
    else {
        return;
    }
}
function removeCookieOnLogout() {
    Cookies.remove(cookieName, { path: '/', domain: ylDomain });
    initialCookiePresent = false;
}
function createDomainLevelCookie(userId) {
    Cookies.set(cookieName, userId || 'true', { path: '/', domain: ylDomain });
    initialCookiePresent = true;
}
